import _objectSpread from "/source/HikariRec/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/source/HikariRec/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useBootstrapBreakpoints, useBootstrapMinBreakpoint } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var Row = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "as"]);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'row');
  var breakpoints = useBootstrapBreakpoints();
  var minBreakpoint = useBootstrapMinBreakpoint();
  var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
  var classes = [];
  breakpoints.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;
    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }
    var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
    if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
  });
  return /*#__PURE__*/_jsx(Component, _objectSpread({
    ref: ref
  }, props, {
    className: classNames.apply(void 0, [className, decoratedBsPrefix].concat(classes))
  }));
});
Row.displayName = 'Row';
export default Row;